var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tooltip-icon',{attrs:{"icon":_vm.icon,"color":_vm.iconColor,"text":_vm.text,"large":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }